import React, { useState, useEffect } from 'react'
import { Modal, message } from 'antd'
import { Input } from "reactstrap"
import { updateBarcode } from '../../../../services/api/apiBarcode'
import { pushNewItemHistory } from '../../../../services/api/apiItemHistory'

function ResendTikTokModal(props) {
    const { visible = false, onClose, item = {}, reloadItems } = props || {}
    const [name, setName] = useState('')
    const [address1, setAddress1] = useState('')
    const [address2, setAddress2] = useState('')
    const [city, setCity] = useState('')
    const [state, setState] = useState('')
    const [country, setCountry] = useState('')
    const [phone, setPhone] = useState('')
    const [postalCode, setPostalCode] = useState('')

    useEffect(() => {
        setName(item.name || '')
        setAddress1(item.address1 || '')
        setAddress2(item.address2 || '')
        setCity(item.city || '')
        setState(item.state || '')
        setCountry(item.country || '')
        setPhone(item.phone || '')
        setPostalCode(item.postalCode || '')
    }, [visible])

    const handleChangeInput = (e) => {
        const { type, checked, name } = e.target
        const value = type === 'checkbox' ? checked : e.target.value
        if (name === 'name') setName(value)
        if (name === 'address1') setAddress1(value)
        if (name === 'address2') setAddress2(value)
        if (name === 'city') setCity(value)
        if (name === 'state') setState(value)
        if (name === 'country') setCountry(value)
        if (name === 'phone') setPhone(value)
        if (name === 'postalCode') setPostalCode(value)
    }
    const _diff = (oldObj, newObj) =>
        Object.keys(newObj).filter(key => !Object.is(oldObj[key], newObj[key]))

    const handleResend = async () => {
        const payload = {
            name,
            address1,
            address2,
            postalCode,
            city, state,
            country, phone,
            isResendTiktokInfo: true,
        }
        try {
            const resUpdated = await updateBarcode(item._id, payload)
            const { success, data = {}, message: mess } = resUpdated.data || {}
            if (!success) {
                throw new Error(mess)
            }
            const oldData = {
                name: item.name || '',
                address1: item.address1 || '',
                address2: item.address2 || '',
                city: item.city || '',
                state: item.state || '',
                country: item.country || '',
                phone: item.phone || '',
                postalCode: item.postalCode || '',
                gen_time: item.gen_time,
            }

            const newData = {
                name: data.name || '',
                address1: data.address1 || '',
                address2: data.address2 || '',
                city: data.city || '',
                state: data.state || '',
                country: data.country || '',
                phone: data.phone || '',
                postalCode: data.postalCode || '',
                gen_time: data.gen_time,
            }

            const diff = _diff(oldData, newData)
            let from = {}
            let to = {}
            diff.forEach(key => {
                from[key] = oldData.hasOwnProperty(key) ? oldData[key] : ''
                to[key] = newData.hasOwnProperty(key) ? newData[key] : ''
            })

            pushNewItemHistory(`${item.barcodeNumber}_1`, {
                event_key: 'resend_tiktok',
                event_description: 'Resend TikTok.',
                event_meta: { from, to }
            })
            onClose()
            reloadItems()
            message.success(`Resend TikTok success!`)
        } catch (error) {
            message.error(error.message)
        }
    }

    return (
        <Modal
            title='Resend TikTok'
            className='ResendTikTokModal'
            visible={visible}
            okText='Resend'
            onCancel={onClose}
            onOk={handleResend}
        >
            <div className='ResendTikTokModalContent'>
                <h3>Shipping address</h3>
                <div className='shippingAddressItem align-items-center d-flex mb-2'>
                    <span className='mr-2 mb-0' style={{ minWidth: 77 }}>Name</span>
                    <Input name='name' value={name} onChange={handleChangeInput} />
                </div>
                <div className='shippingAddressItem align-items-center d-flex mb-2'>
                    <span className='mr-2 mb-0' style={{ minWidth: 77 }}>Address1</span>
                    <Input name='address1' value={address1} onChange={handleChangeInput} />
                </div>
                <div className='shippingAddressItem align-items-center d-flex mb-2'>
                    <span className='mr-2 mb-0' style={{ minWidth: 77 }}>Address2</span>
                    <Input name='address2' value={address2} onChange={handleChangeInput} />
                </div>
                <div className='shippingAddressItem align-items-center d-flex mb-2'>
                    <span className='mr-2 mb-0' style={{ minWidth: 77 }}>City</span>
                    <Input name='city' value={city} onChange={handleChangeInput} />
                </div>
                <div className='shippingAddressItem align-items-center d-flex mb-2'>
                    <span className='mr-2 mb-0' style={{ minWidth: 77 }}>State</span>
                    <Input name='state' value={state} onChange={handleChangeInput} />
                </div>
                <div className='shippingAddressItem align-items-center d-flex mb-2'>
                    <span className='mr-2 mb-0' style={{ minWidth: 77 }}>Country</span>
                    <Input name='country' value={country} onChange={handleChangeInput} />
                </div>
                <div className='shippingAddressItem align-items-center d-flex mb-2'>
                    <span className='mr-2 mb-0' style={{ minWidth: 77 }}>Phone</span>
                    <Input name='phone' value={phone} onChange={handleChangeInput} />
                </div>
                <div className='shippingAddressItem align-items-center d-flex mb-2'>
                    <span className='mr-2 mb-0' style={{ minWidth: 77 }}>Postal Code</span>
                    <Input name='postalCode' value={postalCode} onChange={handleChangeInput} />
                </div>
            </div>
        </Modal>
    )
}

export default ResendTikTokModal